import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { quickWebLogger } from '@quickweb/logger';
@Component({
  selector: 'app-error-income',
  templateUrl: './error-income.page.html',
  styleUrls: ['./error-income.page.scss'],
})
export class ErrorIncomePageComponent extends DefaultPageComponent implements OnInit {

  headerId = 'error-income';
  titlePage = 'Renda e patrimônio';
  label = 'Renda e patrimônio';
  titleInf = '';
  subTitleInf = '';

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    private title: Title,
    public returnNativeService: ReturnNativeService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.titleInf = localStorage.getItem('titleInf');
    this.subTitleInf = localStorage.getItem('subTitleInf');
    quickWebLogger.rum.startView({ pageName: `${this.journeyService.journey}/${location.hash}` });
  }

  ionViewWillEnter() {
    this.headerFocus();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    this.router.back();
  }

  getPageId(): string {
    return this.headerId;
  }
  
  backPage() {
    this.router.back();
  }
}
